import { createAction } from 'redux-act';
// report-common
import { getReportActions } from '../../report-common';
//////////////////////////////////////////////////

const {
  setReports,
  setUsedReport,
  setListLoading,
  setFilterProps,
  setInitialState,
  setReportPending,
  setTableTitleSort,
  deleteItemSuccess,
  getItemListRequest,
  getItemListSuccess,
  createReportRequest,
  updateReportRequest,
  setTableTitleFilter,
  setIgnorePromptStatus,
  resetListAndPagination,
  exportReportDataRequest,
  setInitialStateOmitReport,
  changeDefaultReportRequest,
  getAvailableReportsRequest,
} = getReportActions();

const toggleDetails = createAction('toggleDetails');
const setDriverGuid = createAction('setDriverGuid');
const setVendorGuid = createAction('setVendorGuid');
const setBranchConfigs = createAction('setBranchConfigs');
const removeCompensationGroupRequest = createAction('removeCompensationGroupRequest');
const removeCompensationGroupSuccess = createAction('removeCompensationGroupSuccess');
const getCompensationGroupByGuidSuccess = createAction('getCompensationGroupByGuidSuccess');
const getCompensationsByGroupGuidRequest = createAction('getCompensationsByGroupGuidRequest');
const createOrUpdateCompensationGroupRequest = createAction('createOrUpdateCompensationGroupRequest');
const createOrUpdateCompensationGroupSuccess = createAction('createOrUpdateCompensationGroupSuccess');
const visitCompensationGroupOnFleetProfilePage = createAction('visitCompensationGroupOnFleetProfilePage');
const removeCompensationGroupCompensationRequest = createAction('removeCompensationGroupCompensationRequest');
const removeCompensationGroupCompensationSuccess = createAction('removeCompensationGroupCompensationSuccess');
const createOrUpdateCompensationGroupCompensationRequest =
  createAction('createOrUpdateCompensationGroupCompensationRequest');
const createOrUpdateCompensationGroupCompensationSuccess =
  createAction('createOrUpdateCompensationGroupCompensationSuccess');

export {
  // report
  setReports,
  setUsedReport,
  setListLoading,
  setFilterProps,
  setInitialState,
  setReportPending,
  setTableTitleSort,
  deleteItemSuccess,
  getItemListRequest,
  getItemListSuccess,
  updateReportRequest,
  createReportRequest,
  setTableTitleFilter,
  setIgnorePromptStatus,
  resetListAndPagination,
  exportReportDataRequest,
  setInitialStateOmitReport,
  changeDefaultReportRequest,
  getAvailableReportsRequest,
  // compensation-group
  setDriverGuid,
  toggleDetails,
  setVendorGuid,
  setBranchConfigs,
  removeCompensationGroupRequest,
  removeCompensationGroupSuccess,
  getCompensationsByGroupGuidRequest,
  getCompensationGroupByGuidSuccess,
  createOrUpdateCompensationGroupRequest,
  createOrUpdateCompensationGroupSuccess,
  visitCompensationGroupOnFleetProfilePage,
  removeCompensationGroupCompensationRequest,
  removeCompensationGroupCompensationSuccess,
  createOrUpdateCompensationGroupCompensationRequest,
  createOrUpdateCompensationGroupCompensationSuccess,
};
